import { QuantumScene } from "./scene/QuantumScene";
import { Overlay } from "./ui/Overlay";
import { ScrollProvider } from "./scroll/ScrollProvider";

export default function App() {
  return (
    <ScrollProvider>
      <QuantumScene />
      <Overlay />
    </ScrollProvider>
  );
}
